import { Component, OnInit, HostListener, ViewEncapsulation } from '@angular/core';
import { DataWpServiceTestimonios } from '../../data-wp.service';

@Component({
  selector: 'app-testimonios',
  templateUrl: './testimonios.component.html',
  styleUrls: ['./testimonios.component.css'],
  providers: [DataWpServiceTestimonios],
  encapsulation: ViewEncapsulation.None
})
export class TestimoniosComponent implements OnInit {
  constructor(private dataWp: DataWpServiceTestimonios) { }
  
  testimonios: any[] = [];
  
 ngOnInit() {
  this.dataWp.getPosts().subscribe((posts: any) => {
    console.log('Posts recibidos:', posts);
    if (posts && posts.length > 0 && posts[0].acf) {
      this.testimonios = posts[0].acf.combo.map((item: any) => ({
        nombre: item.nombre,
        mensaje: item.descripcion,
      }));
    //this.testimonios = posts;
    }
  }); // Agregar este paréntesis y punto y coma que faltaba
}

  slickConfig = {
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  infinite: true,
  arrows: false,
  autoplay: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1, // Mostrar solo un elemento en pantallas pequeñas
        slidesToScroll: 1,
        arrows: true,
        dots: true,
      }
    }
  ]
};

}